import { Component, OnInit, Input } from '@angular/core';

import { StatusService } from '../Services/status.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-all-target',
  templateUrl: './all-target.component.html',
  styleUrls: ['./all-target.component.css']
})
export class AllTargetComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;
  division_code = 0;
  @Input() year: number;
  @Input() month: number;

  years: number[] = [2018, 2017, 2016, 2015, 2014];
  months: any[] = [
    { month: 7, disabled: false },
    { month: 8, disabled: false },
    { month: 9, disabled: false },
    { month: 10, disabled: false },
    { month: 11, disabled: false },
    { month: 12, disabled: false },
    { month: 1, disabled: false },
    { month: 2, disabled: false },
    { month: 3, disabled: false },
    { month: 4, disabled: false },
    { month: 5, disabled: false },
    { month: 6, disabled: false },
  ];
  //  year: number;
  //  month: number;
  weekNo;
  recordList: any;
  edit;
  prevRecord;
  nowRecord;

  constructor(
    private statusService: StatusService,
    public authService: AuthService,
  ) { }

  ngOnInit() {
    //    this.year = new Date().getFullYear();
    //    this.month = new Date().getMonth() + 1;
    //    if (this.month < 7) {
    //      this.year--;
    //    }
    this.weekNo = this.checkWeekNo(this.getWeekNo(this.year, this.month), new Date());
    this.changeRecord();
  }

  checkWeekNo(weekNo, date) {
    let week = 1;
    while (weekNo[week].end < date) {
      week++;
    }
    return week;
  }

  getWeekNo(year, month) {
    if (month < 7) year++;
    let now = new Date(year, month - 1, 1);
    let dt = new Date(year, month - 1, 1);

    // dtを指定月の最初の週の開始日にする
    let mon = dt.getDay();
    if (mon > 1) {
      dt.setDate(dt.getDate() + (8 - dt.getDay()));
    } else if (mon == 0) {
      dt.setDate(dt.getDate() + 1)
    }

    let weeksOfMonth = [];
    let weekNo = 1;
    while (dt.getMonth() == now.getMonth()) {
      weeksOfMonth[weekNo++] = { 'start': new Date(dt), 'end': new Date(dt.setDate(dt.getDate() + 6)) };
      dt.setDate(dt.getDate() + 1);
    }
    return weeksOfMonth;
  }

  //未来のチェックボックスをクリック不可に
  ListHide() {
    this.months.forEach(item => {
      var y = this.year;
      if (item.month < 7) y++;
      let sel = new Date(y, item.month);
      let now = new Date(new Date().getFullYear(), new Date().getMonth() + 1);
      if (now < sel) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });
  }

  // 投げられた年月の実績を取得
  SearchRecord() {
    let checkYm = this.month < 7 ? ((this.year + 1) + '' + this.month) : this.year + '' + this.month;
    let nowYm = (new Date().getFullYear()) + '' + (new Date().getMonth() + 1);
    if (this.recordList) {
      if (nowYm > checkYm) {
        this.edit = false;
      } else {
        this.edit = true;
      }
      /*
      if (new Date().getFullYear() == this.year && new Date().getMonth() == this.month - 1) {
        this.edit = true;
      } else {
        this.edit = false;
      }
      */
      let prevMonth = this.month == 1 ? 12 : this.month - 1;
      this.nowRecord = this.recordList.filter((item) => item.month == this.month);
      this.prevRecord = this.recordList.filter((item) => item.month == prevMonth);
    }
  }

  //指定年度のレコード取得
  changeRecord() {
    this.recordList = null;
    this.prevRecord = null;
    this.nowRecord = null;

    this.statusService.getDivisionStatusList(this.division_code, this.year).subscribe(res => {
      this.recordList = res;
      this.SearchRecord();
    });
  }

  //月間目標を各週に割振り
  Allocation() {
    let week = this.nowRecord.length - this.weekNo;
    let new_temp = this.nowRecord[0].new_target;
    let ap_temp = this.nowRecord[0].ap_target;
    let app_temp = this.nowRecord[0].app_target;
    let contract_temp = this.nowRecord[0].contract_target;
    for (let i = 1; i < this.nowRecord.length; i++) {
      //再設定した目標から現実績を引く
      if (i < this.weekNo) {
        new_temp -= this.nowRecord[i].new_actual;
        if (new_temp < 0) new_temp = 0;
        ap_temp -= this.nowRecord[i].ap_actual;
        if (ap_temp < 0) ap_temp = 0;
        app_temp -= this.nowRecord[i].app_result;
        if (app_temp < 0) app_temp = 0;
        contract_temp -= this.nowRecord[i].contract_record;
        if (contract_temp < 0) contract_temp = 0;
      } else {
        //残りの週に割振
        this.nowRecord[i].new_target = new_temp / week;
        this.nowRecord[i].ap_target = ap_temp / week;
        this.nowRecord[i].app_target = app_temp / week;
        this.nowRecord[i].contract_target = contract_temp / week;
      }
    }
  }

  save() {
    this.statusService.updateDivisionStatus(this.nowRecord);
  }
}
